import { Location } from './../../core/app/common/Location';
import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import * as aspObjects from './../../core/app/asp/aspObjects';
import { AspObject } from './../../core/app/asp/AspObject';
import { SensorObject } from './SensorObject';
import { AppConfig } from '../../core/app/app.config';

export class NaiNatHandler extends MsgHandler {
  private static _self: NaiNatHandler = null;

  private constructor() {
    super(consts.MSG_TYPE_NAI);
  }

  public static getSelf(): NaiNatHandler {
    if (this._self == null)
      this._self = new NaiNatHandler();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("nainat msg:", msgObj);
    // search the right sensor
    let object = aspObjects.sensorsPool.getSensorBySicSac(msgObj.Sic, msgObj.Sac) as SensorObject;
    if (!object) { return; }

    if (msgObj.GeometricShape == 0 && msgObj.PolygonPoints.length < 3 && msgObj.OperationAction != 2) {
      console.error((msgObj.NaiOrNat == 1 ? "Nai" : "Nat") + " Polygon has arrived with less than 3 points...");
      return;
    }
    //update drawing
    object.updateNatNai(msgObj);
  }
}
